'use es6';

import { Record } from 'immutable';
export default Record({
  reviewState: undefined,
  portalLevel: undefined,
  slaCopyType: undefined,
  contentType: undefined
}, 'ContentData');